import { z } from "zod"

import { MAX_SURCHARGES_PER_ROW } from "@/screens/Pricing/components/tables/constants"

export const surchargeItemSchema = z.object({
  price: z
    .number({ required_error: "Surcharge Price is required" })
    .nullable()
    .refine((value) => value !== null, {
      message: "Surcharge Price is required",
    }),
  description: z.string().min(1, "Description is required"),
})

export const surchargeFormSchema = z.object({
  surcharges: z.array(surchargeItemSchema).min(1).max(MAX_SURCHARGES_PER_ROW),
})

export type SurchargeItem = z.infer<typeof surchargeItemSchema>
export type SurchargeFormValues = z.infer<typeof surchargeFormSchema>
